export const FETCH_START = 'buffers/FETCH_START'
export const FETCH_SUCCESS = 'buffers/FETCH_SUCCESS'
export const FETCH_FAILURE = 'buffers/FETCH_FAILURE'

export const OPEN_EDITOR = 'buffers/OPEN_EDITOR'
export const CLOSE_EDITOR = 'buffers/CLOSE_EDITOR'
export const SET_EDIT_DISTANCE = 'buffers/SET_EDIT_DISTANCE'
export const SET_EDIT_UNIT = 'buffers/SET_EDIT_UNIT'
export const SET_EDIT_LAYER = 'buffers/SET_EDIT_LAYER'

export const SAVE = 'buffers/SAVE'
export const CREATE = 'buffers/CREATE'
export const REMOVE = 'buffers/REMOVE'
export const MARK_CLEAN = 'buffers/MARK_CLEAN'

export const SHOW = 'buffers/SHOW'
export const HIDE = 'buffers/HIDE'
export const SELECT = 'buffers/SELECT'
export const DESELECT = 'buffers/DESELECT'
export const HOVER = 'buffers/HOVER'
export const END_HOVER = 'buffers/END_HOVER'
